import React, { useState, useEffect } from 'react';
import {
  Popup,
  List,
  SearchBar,
  Tabs,
  Button,
  Toast,
  SpinLoading,
  Space,
  Tag
} from 'antd-mobile';
import { HotelOutline, CloseOutline } from 'antd-mobile-icons';

import {
  ExclamationCircleOutlined, FilterOutlined,  
  DeleteOutlined,LoadingOutlined ,
  SearchOutlined,
  CalendarOutlined,
  UserOutlined,
  HomeOutlined,  
} from '@ant-design/icons';
import axios from 'axios';
import { BASE_URL } from '../utils/constants';
import dayjs from 'dayjs';

const AsignarHabitacionMovil = ({ visible, onClose, onSuccess, lineaSeleccionada }) => {
  const [habitaciones, setHabitaciones] = useState([]);
  const [filteredHabitaciones, setFilteredHabitaciones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [searchText, setSearchText] = useState('');
  const [asignando, setAsignando] = useState(false);

  useEffect(() => {
    if (visible && lineaSeleccionada) {
      cargarHabitacionesDisponibles();
    }
  }, [visible, lineaSeleccionada]);

  useEffect(() => {
    let filtered = [...habitaciones];
    if (searchText) {
      filtered = filtered.filter(h => 
        h.numhab?.toString().includes(searchText) ||
        h.tipo?.toLowerCase().includes(searchText.toLowerCase())
      );
    }
    setFilteredHabitaciones(filtered);
  }, [searchText, habitaciones]);

  const cargarHabitacionesDisponibles = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem('token');
      const entrada = dayjs(lineaSeleccionada.entrada).format('YYYY-MM-DD');
      const salida = dayjs(lineaSeleccionada.salida).format('YYYY-MM-DD');
      
      const response = await axios.get(
        `${BASE_URL}/api/reservas/disponibles/habitaciones`,
        {
          params: { entrada, salida, tipoHab: lineaSeleccionada.tipohab },
          headers: { Authorization: `Bearer ${token}` }
        }
      );
      
      setHabitaciones(response.data.data || []);
      setFilteredHabitaciones(response.data.data || []);
    } catch (error) {
      Toast.show({
        content: 'Error al cargar habitaciones',
        icon: 'fail'
      });
    } finally {
      setLoading(false);
    }
  };

  const asignarHabitacion = async (numHab) => {
    setAsignando(true);
    try {
      const token = localStorage.getItem('token');

      console.log(lineaSeleccionada.linea,numHab);
      
      await axios.put(
        `${BASE_URL}/api/reservas/${lineaSeleccionada.numreserva}/asignar-habitacion`,
        {
          linea: lineaSeleccionada.linea,
          numHabitacion: numHab,
          aplicarATodaHabitacion: true
        },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      
      Toast.show({
        content: `Habitación ${numHab} asignada`,
        icon: 'success'
      });
      
      onSuccess?.();
      onClose();
    } catch (error) {
      Toast.show({
        content: error.response?.data?.error || 'Error al asignar',
        icon: 'fail'
      });
    } finally {
      setAsignando(false);
    }
  };

  return (
    <Popup
      visible={visible}
      onMaskClick={onClose}
      position='bottom'
      bodyStyle={{ height: '70vh', borderRadius: '16px 16px 0 0' }}
    >
      <div style={{ padding: 16 }}>
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 16 }}>
          <h3>Asignar Habitación</h3>
          <Button fill='none' onClick={onClose}>
            <CloseOutline fontSize={20} />
          </Button>
        </div>
        
        {lineaSeleccionada && (
          <div style={{ marginBottom: 16, padding: 12, background: '#f5f5f5', borderRadius: 8 }}>
            <div>Cliente: {lineaSeleccionada.nombre}</div>
            <div>Reserva: #{lineaSeleccionada.numreserva} - Línea {lineaSeleccionada.linea}</div>
            <div>Tipo Habitación: {lineaSeleccionada.tipohab}</div>
          </div>
        )}
        
        <SearchBar
          placeholder='Buscar habitación...'
          value={searchText}
          onChange={setSearchText}
          clearable
          style={{ marginBottom: 16 }}
        />
        
        {loading ? (
          <SpinLoading style={{ display: 'block', textAlign: 'center', marginTop: 40 }} />
        ) : (
          <div style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fill, minmax(100px, 1fr))',
            gap: 12,
            maxHeight: 'calc(70vh - 200px)',
            overflow: 'auto'
          }}>
            {filteredHabitaciones.map(hab => (
              <div
                key={hab.numhab}
                onClick={() => asignarHabitacion(hab.NumHab)}
                style={{
                  padding: 12,
                  textAlign: 'center',
                  background: '#f5f5f5',
                  borderRadius: 8,
                  cursor: 'pointer',
                  border: '1px solid #e5e5e5'
                }}
              >
                <HomeOutlined fontSize={24} style={{ color: '#1677ff' }} />
                <div style={{ fontWeight: 'bold', fontSize: 18, marginTop: 4 }}>{hab.NumHab}</div>
                <div style={{ fontSize: 12, color: '#666' }}>{hab.TipoHab|| 'Standard'}</div>
                <Tag color='success' size='small' style={{ marginTop: 4 }}>Disponible</Tag>
              </div>
            ))}
          </div>
        )}
        
        {asignando && (
          <div style={{ textAlign: 'center', marginTop: 16 }}>
            <SpinLoading />
          </div>
        )}
      </div>
    </Popup>
  );
};

export default AsignarHabitacionMovil;